import styles from "./MobileInvoiceCard.module.scss";
import download from "../../assets/icons/download.svg";
import downloadHover from "../../assets/icons/download-hover.svg";
import { useTranslation } from "react-i18next";
import { useToast } from "../../hooks/useToast";

interface MobileInvoiceCardProps {
  id: string;
  date: string;
  product: string;
  price: string;
}

const MobileInvoiceCard: React.FC<MobileInvoiceCardProps> = ({
  id,
  date,
  product,
  price,
}) => {
  const { t } = useTranslation();
  const { showToast } = useToast();


  return (
    <>
      <div className={styles.root}>
        <p className={styles.root_title}>{t('Invoice')} #</p>
        <div className={styles.root_download}>
          <p className={styles.root_download_num}> {id}</p>
          <img
            src={download}
            alt="download"
            onMouseOver={(e) => (e.currentTarget.src = downloadHover)}
            onMouseOut={(e) => (e.currentTarget.src = download)}
            onClick={() => showToast(t("Your invoice is being generated! It will open in a new tab shortly."))
            }
            className={styles.root_img}
            width={24}
            height={24}
          />
        </div>
        <div className={styles.root_card}>
          <div className={styles.root_info}>
            <p className={styles.root_info_name}>{t("Date")}</p>
            <p className={styles.root_info_value}>{date}</p>
          </div>
          <div className={styles.root_info}>
            <p className={styles.root_info_name}>{t("Product")}</p>
            <p className={styles.root_info_value}>{product}</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default MobileInvoiceCard;
